import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { categories } from './api';
import Header from './Header';

import './MainPage.scss';

class MainPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      entries: []
    };
  }

  componentDidMount() {
    categories().then((entries) => this.setState({ entries }));
  }

  render() {
    return (
      <div className={'main-page'}>
        <Header title="라이엇 게임즈 법률관련 문서" />
        <div className={'categories'}>
          {this.state.entries.map(({ logo, title, legals }, index) => (
            <div key={index} className={'category'}>
              <div className={'section'}>
                <div className={'logo'}>
                  <img src={logo} alt={'logo'} />
                </div>
                <div className={'title'}>{title}</div>
              </div>
              {legals.map((legals, index) => (
                <div key={index} className={'nav'}>
                  <NavLink to={`${legals.uri}?current=${legals.docId}`}>{legals.title}</NavLink>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default MainPage;
